import rules from '../../helpers/rowRules';

const { template, job, additionTab, order } = rules;

export const getAllowedItemsList = (state) => {
  const { data, idName } = state;
  const ItemsAllowed = [];

  if (data && data.length > 0) {
    data.forEach((row) => {
      if (isRowAllowedToBeDelete(state, row)) ItemsAllowed.push(row[idName]);
    });
  }
  return ItemsAllowed;
};

export const isRowAllowedToBeDelete = (state, row) => {
  const { idName, tableCode } = state;
  const { UserName, IsInternalUser, IsSuperUser} = state.userInfo;

  const actionCode = 'multiDelete';

  
  if (
    chooseRulesToApply(
      tableCode,
      actionCode,
      row,
      UserName,
      state.userInfo,
    )
  )
    return row[idName];

  return false;
};

const chooseRulesToApply = (
  tableCode,
  actionCode,
  row,
  UserName,
  userInfo,
  ) => {
  switch (tableCode) {
    case 'templates':
      return template(
        { code: actionCode },
        row,
        UserName,
        userInfo,
      );

    case 'jobs':
      return job({ code: actionCode }, row);
    case 'prepaidRequest':
      return job({ code: actionCode }, row);

    case 'additionTab':
      return additionTab({ code: actionCode }, row);

    case 'supplies':
      return order({ code: actionCode }, row);

    default:
      return false;
  }
};



// WEBPACK FOOTER //
// ./src/MultiDeletionFunctionality/@helper_functions/helpers.js